define("shared/utils/image-tag", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  // TODO: Draggable
  // TODO: Add "ready" event
  const defaultConfig = {
    isDisabled: false,
    isPercentage: true,
    allowOverflow: false,
    className: 'tag-point',
    pointTextClassName: 'point-text',
    activeClassName: 'active',
    seedData: undefined
  };
  class ImageTag {
    constructor(className) {
      let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.wrapper = document.querySelector(className);
      this.image = this.wrapper.querySelector('img');

      // Stops the native browser image drag
      this.image.draggable = false;
      this.points = [];

      // Config Options
      this.config = Object.assign({}, defaultConfig, config);
      if (!config.allowOverflow) {
        this.wrapper.style.position = 'relative';
      }
      if (config.seedData) {
        this.seedPoints(config.seedData);
      }
      this.image.addEventListener('click', event => this._handleClick(event));
    }

    // ===============
    // Public APIs
    // ===============

    newPoint() {
      const point = this._buildPoint();
      const position = {
        x: this._handleUnit(this.image.width / 2, this.image.width),
        y: this._handleUnit(this.image.height / 2, this.image.height)
      };
      this.positionPoint(point, position);
      this._displayPoint(point);
      this._savePoint(point);
      this.setActivePoint(point);
    }
    seedPoints(seeds) {
      this.clearPoints();
      seeds.forEach(seed => {
        const point = this._buildPoint(seed);
        this.positionPoint(point);
        this._displayPoint(point);
        this._savePoint(point);
      });
    }
    getPointById(id) {
      return this.points.filter(point => point.id === id)[0];
    }
    getActivePoint() {
      return this.points.filter(point => point.isActive)[0];
    }
    setActivePoint(activePoint) {
      this.points.forEach(point => {
        this._applyClassNames(point);
        point.isActive = point.id === activePoint.id;
        if (point.isActive) {
          point.element.style.zIndex = 1;
        }
      });
      this._applyActiveClassName(activePoint);
    }
    removePoint(pointToRemove) {
      pointToRemove.element.remove();
      this.points = this.points.filter(point => point.id !== pointToRemove.id);
    }
    positionPoint(point) {
      let position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      point.x = position.x || point.x;
      point.y = position.y || point.y;
      point.element.style.left = point.x + this._getUnitSymbol();
      point.element.style.top = point.y + this._getUnitSymbol();
      this.wrapper.classList.add('is--retag');
      setTimeout(() => {
        this.wrapper.classList.remove('is--retag');
      }, 600);
    }
    saveAllPoints() {
      this.points.forEach(point => {
        point.isActive = false;
        this._applyClassNames(point);
      });
    }
    disableNewPoints() {
      this.config.isDisabled = true;
    }
    enableNewPoints() {
      this.config.isDisabled = false;
    }
    clearPoints() {
      this.points.forEach(point => point.element.remove());
      this.points = [];
    }

    // ===============
    // Private APIs
    // ===============

    _handleClick(event) {
      if (this.config.isDisabled) {
        return;
      }
      const point = this.getActivePoint();
      if (point) {
        this.positionPoint(point, {
          x: this._handleUnit(event.offsetX, event.target.width),
          y: this._handleUnit(event.offsetY, event.target.height)
        });
      }
    }
    _buildPoint() {
      let {
        x = 0,
        y = 0,
        id,
        text = ''
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const point = {
        y,
        x,
        id,
        text,
        element: document.createElement('div'),
        isActive: false
      };
      this._applyClassNames(point, id);
      this._applyPointText(point);
      return point;
    }
    _applyClassNames(point, id) {
      this._removeClassNames(point);
      const uniqueId = id || point.id || Date.now();
      const {
        element
      } = point;
      element.classList.add(this.config.className);
      element.classList.add(`${this.config.className}-${uniqueId}`);
    }
    _removeClassNames(point) {
      point.element.className = '';
    }
    _applyActiveClassName(point) {
      const {
        element
      } = point;
      element.classList.add(this.config.activeClassName);
    }
    _applyPointText(point) {
      point.element.innerHTML = `<div class="${this.config.pointTextClassName}">${point.text}</div>`;
    }
    _savePoint(point) {
      this.points.push(point);
    }
    _displayPoint(point) {
      this.wrapper.appendChild(point.element);
    }
    _handleUnit(pointLocation, maxLocation) {
      return this.config.isPercentage ? this._toPercentage(pointLocation, maxLocation) : pointLocation;
    }
    _getUnitSymbol() {
      return this.config.isPercentage ? '%' : 'px';
    }
    _toPercentage(pointLocation, maxLocation) {
      return pointLocation / maxLocation * 100;
    }
  }
  _exports.default = ImageTag;
});